import React from 'react';
import { Box } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import SchoolIcon from '@mui/icons-material/School';
import GroupsIcon from '@mui/icons-material/Groups';

export function TabPanel({ children, value, index, sx: sxOverride }) {
  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      sx={sxOverride || { height: '100%', overflow: 'auto' }}
    >
      {value === index && children}
    </Box>
  );
}

export const ENTITY_ICONS = {
  person: PersonIcon,
  organization: BusinessIcon,
  program: SchoolIcon,
  community: GroupsIcon,
};

export const BRAND_COLORS = {
  primary: '#100331', // Dark purple
  secondary: '#FF3749', // Red/coral
  accent: '#C9A0DC', // Light purple
};

export const getInitials = (name) => {
  if (!name) return '?';
  const parts = name.split(' ');
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
};
